import React from 'react';
import InventoryIcon from '@mui/icons-material/Inventory';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CategoryIcon from '@mui/icons-material/Category';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import EuroIcon from '@mui/icons-material/Euro';
import SectionLayout from '../../components/layout/SectionLayout';
import { SideSection } from '../../components/layout/SideNav';

const SECTIONS: SideSection[] = [
  {
    label: 'Visão geral',
    links: [{ label: 'Painel', path: '/expenses', icon: <DashboardIcon /> }],
  },
  {
    label: 'Despesas da casa',
    links: [
      { label: 'Despesas da casa', path: '/expenses/home-expenses', icon: <HomeOutlinedIcon /> },
      { label: 'Grupos de despesas', path: '/expenses/groups', icon: <CategoryIcon /> },
      { label: 'Categorias', path: '/expenses/categories', icon: <FolderOutlinedIcon /> },
      { label: 'Contas', path: '/expenses/accounts', icon: <AccountBalanceIcon /> },
      { label: 'Importar/Exportar', path: '/expenses/import-export', icon: <ImportExportIcon /> },
      { label: 'Orçamentos', path: '/expenses/budgets', icon: <AccountBalanceWalletIcon /> },
    ],
  },
  {
    label: 'Despesas pessoais',
    links: [
      { label: 'Despesas pessoais', path: '/expenses/personal-expenses', icon: <PersonOutlineIcon /> },
      { label: 'Grupos', path: '/expenses/personal-groups', icon: <CategoryIcon /> },
      { label: 'Categorias', path: '/expenses/personal-categories', icon: <FolderOutlinedIcon /> },
      { label: 'Contas', path: '/expenses/personal-accounts', icon: <AccountBalanceIcon /> },
    ],
  },
  {
    label: 'Gestão',
    links: [
      { label: 'Produtos', path: '/expenses/products', icon: <InventoryIcon /> },
      { label: 'Faturas', path: '/expenses/invoices', icon: <ReceiptIcon /> },
      { label: 'Locais', path: '/expenses/locations', icon: <LocationOnIcon /> },
    ],
  },
];

const ExpensesLayout: React.FC = () => (
  <SectionLayout title="Gestão de despesas" icon={<EuroIcon fontSize="small" />} sections={SECTIONS} />
);

export default ExpensesLayout;
